import React from "react";
import classNames from "classnames";

const CheckboxInput = ({
  id,
  dataCy,
  checked = false,
  onChange,
  label = "Checkbox label",
  hideLabel = false,
  align = "left",
  disabled = false
}) => {
  let svgClasses = label == ""
    ? "pointer-events-none absolute left-[2px] top-[1px] w-[16px] h-[16px] text-white"
    : "pointer-events-none absolute left-[2px] top-[1px] w-[16px] h-[20px] text-white";
  return (
    <div className={classNames(
      "relative flex items-center gap-3 w-full",
      align === "right" ? "justify-end" : "",
      align === "left" ? "justify-start" : "",
      align === "center" ? "justify-center" : ""
    )}>
      {/* Checkbox container */}
      <label htmlFor={id} className="relative flex items-center cursor-pointer select-none">
        <input
          id={id}
          data-cy={dataCy}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={(e) => !disabled && onChange(e.target.checked)}
          className={classNames(
            "peer appearance-none w-[20px] h-[20px] border-[2px] rounded-[4px] transition-colors",
            disabled
              ? "border-gray-400 checked:bg-[var(--color-gray-400)] checked:border-transparent cursor-not-allowed"
              : "border-gray-800 checked:bg-[var(--color-gray-800)] checked:border-transparent cursor-pointer"
          )}
        />
        {/* Checkmark (visible only when checked) */}
        <svg
          className={classNames(
            svgClasses,
            !checked && "hidden"
          )}
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="4 10 8 14 16 6" />
        </svg>
        {/* Label text inside the label for clickable area */}
        {!hideLabel && <span
          className={classNames(
            "tw-paragraph-reg ml-2"
          )}
        >
          {label}
        </span>}
      </label>
    </div>
  );
};

export default CheckboxInput;